import { natoLevels, standardLevels } from './levels';
import otherMarkAbbreviations from './otherMarkAbbreviations';
import portionMarkBannerLineTranslations from './portionMarkBannerLineTranslations';
import type { MarkComponent } from './types';

interface PortionMarkBannerLineValueTranslator {
  toBannerLine(value: string): string;
  toPortionMark(value: string): string;
}

function createPortionMarkBannerLineValueTranslator(
  components: MarkComponent[]
): PortionMarkBannerLineValueTranslator {
  const bannerValues: { [key: string]: string } = {};
  const portionValues: { [key: string]: string } = {};

  components.forEach(({ portion, banner }) => {
    bannerValues[banner] = portion;
    portionValues[portion] = banner;
  });

  return {
    toBannerLine(portionValue: string): string {
      return portionValues[portionValue] || portionValue;
    },
    toPortionMark(banner: string): string {
      return bannerValues[banner] || banner;
    },
  };
}

export default createPortionMarkBannerLineValueTranslator([
  ...natoLevels,
  ...standardLevels,
  ...Object.values(otherMarkAbbreviations),
  ...Object.values(portionMarkBannerLineTranslations),
]);
